import React from "react";
import SockJsClient from "react-stomp";

const StompClient = (props) => {
  return <SockJsClient url={process.env.REACT_APP_SOCKET_URL} {...props} />;
};

export default StompClient;
